import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cxShowableGroupPipe',
})
export class CxShowableGroupPipe implements PipeTransform {
  transform(items: any[]): any[] {
    return items.filter((x: any) => !x.deleted);
  }
}
